import CustomQuerySetupWizardSheetStepCommonComponent from 'webapp/components/custom-query/setup/wizard/sheet/step-common';

export default class CustomQuerySetupWizardSheetStepDimensionComponent extends CustomQuerySetupWizardSheetStepCommonComponent {
	override stepTitle = 'Add a dimension to your metric';
	override stepDescription =
		'Optional: Segment your metric further by adding a dimension. If you’d like to segment your metric by multiple dimensions, choose one to complete during this set up, then begin again and select a different dimension until each desired metric is created. To skip this step, select ‘None’.';

	override get isNoneDisabled(): boolean {
		// disable no dimension option if no dates are available at all
		return !this.args.form.columnsForDateCount;
	}

	override get noneDisabledText(): string {
		return this.isNoneDisabled
			? 'Dimension column is required, because the spreadsheet has no date column.'
			: '';
	}
}
